var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:fortune:order:list"],
            expression: "['platform:fortune:order:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
          formatter: _vm.formatter,
        },
        scopedSlots: _vm._u([
          {
            key: "table-user",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _c("div", [_vm._v(_vm._s(row.userName))]),
                  _c("div", [_vm._v("ID: " + _vm._s(row.userId))]),
                ]),
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c("span", { staticClass: "mr10" }, [
                                _vm._v("操作"),
                              ]),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.payStatus === 0
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["platform:fortune:order:repair"],
                                      expression:
                                        "['platform:fortune:order:repair']",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRepair(row)
                                    },
                                  },
                                },
                                [_vm._v("补单")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }